module.exports = __webpack_public_path__ + "static/media/government.452671ec.jpg";